<app-navbar title="Sezon BAG"> </app-navbar>
<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>

<app-season-bag-new-filters
	userFilters="season_bag_new"
	[yesno]="parameters.yesno"
	[names]="parameters.names"
	[statuses]="parameters.statuses"
	(selected)="filtersSelected($event)"
	[forceFilters]="{ limit: 9999 }"
>
</app-season-bag-new-filters>

<mat-table
	[dataSource]="matData"
	matSort
	matSortActive="id"
	matSortDirection="asc"
	grouping="false"
	cdkDropList
	cdkDropListDisabled="true"
>
	<ng-container matColumnDef="checkbox" class="mat-cell-id">
		<mat-header-cell *matHeaderCellDef class="mat-cell-id">
			<mat-checkbox color="primary" (change)="selectAll($event)"></mat-checkbox>
		</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index" class="mat-cell-id"
			><mat-checkbox
				color="primary"
				[(ngModel)]="element.checked"
				(click)="checkMultipleSelection($event, i)"
			></mat-checkbox
		></mat-cell>
	</ng-container>

	<ng-container matColumnDef="id">
		<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-id"> Id </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-id">{{ element.id }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="name">
		<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Nazwa </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.name }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="departureTime">
		<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-date"> Wyjazd </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-date"
			>{{ element.departure }}
			{{ element.departureDay }}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="accommodationFrom">
		<mat-header-cell *matHeaderCellDef class="mat-cell-date"> Zakwaterowanie </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-date">
			<ng-container *ngIf="element.accommodation.lower">
				{{ element.accommodationFrom }}
				{{ element.accommodationFromDay }}
			</ng-container>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="accommodationTo">
		<mat-header-cell *matHeaderCellDef class="mat-cell-date"> Wykwaterowanie </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-date">
			<ng-container *ngIf="element.accommodation.upper">
				{{ element.accommodationTo }}
				{{ element.accommodationToDay }}
			</ng-container>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="returnTime">
		<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-date"> Powrót </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-date"
			>{{ element.return }} {{ element.returnDay }}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="departure">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Wyjazd </mat-header-cell>
		<mat-cell *matCellDef="let element">0 (0) / 0 (0) /0</mat-cell>
	</ng-container>
	<ng-container matColumnDef="return">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Powrót </mat-header-cell>
		<mat-cell *matCellDef="let element">0 (0) /0 (0) /0</mat-cell>
	</ng-container>
	<ng-container matColumnDef="accomodation">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Pokoje </mat-header-cell>
		<mat-cell *matCellDef="let element">0 (0) /0 (0) /0</mat-cell>
		<!-- obliczanie  liczby pokoi  z najmniejszym turnusem + zwrotka jaki turnus-->
		<!-- Zweryfikować czy nie przez button  -->
	</ng-container>
	<ng-container matColumnDef="status">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>

		<mat-cell *matCellDef="let element; let index = index" class="mat-cell-status">
			<mat-select
				[(ngModel)]="element.status"
				[name]="'elementStatus' + index"
				(selectionChange)="changeStatus(element)"
			>
				<mat-option [value]="item.value" *ngFor="let item of statuses" class="mat-cell-status">
					{{ item.viewValue }}
				</mat-option>
			</mat-select>
		</mat-cell>
	</ng-container>
	<ng-container matColumnDef="tourisGuides">
		<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Pilot </mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.tourisGuide }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="confirmTime">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Data potwierdzenia </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.departure }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="swinging">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Wypoczynek </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.swinging }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="button">
		<mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
		<mat-cell *matCellDef="let element">
			<button mat-raised-button color="primary" cdkFocusInitial (click)="openSeasonDialog(element)">
				Więcej
			</button>
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let row; let element; columns: displayedColumns" [ngClass]="element.color"></mat-row>
</mat-table>

<div class="footer">
	<mat-paginator
		[pageSizeOptions]="[10, 20, 50]"
		[pageSize]="50"
		showFirstLastButtons
		aria-label="Select page of periodic elements"
	>
	</mat-paginator>
</div>
